module.exports = __webpack_public_path__ + "img/finish-icon.33d7feb8.svg";